
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TranslationJobSummaryCards extends Vue {
    @Prop({ type: String, default: "" })
    fileName!: string;

    @Prop({ type: Number, default: 0 })
    fileSize!: number;

    @Prop({ type: String, default: "-" })
    sourceLangLabel!: string;

    @Prop({ type: String, default: "" })
    fileIconWrapperClass!: string;

    @Prop({ type: String, default: "" })
    fileIconClass!: string;

    @Prop({ type: Number, default: null })
    words!: number | null;

    @Prop({ type: Number, default: null })
    pages!: number | null;

    @Prop({ type: Number, default: null })
    tokens!: number | null;

    @Prop({ type: Number, default: null })
    costPoint!: number | null;

    @Prop({ type: Number, default: 0 })
    currentBalance!: number;

    @Prop({ type: Number, default: 0 })
    balanceAfter!: number;

    formatMetric(value: number | null | undefined) {
        if (value == null) return "-";
        return value.toLocaleString();
    }

    formatPoints(value: number | null | undefined) {
        if (value == null) return "-";
        return Math.ceil(value).toLocaleString();
    }

    formatFileSize(size?: number | null) {
        if (!size) return "-";
        const mb = size / (1024 * 1024);
        if (mb >= 1) return `${mb.toFixed(1)} MB`;
        const kb = size / 1024;
        return `${kb.toFixed(1)} KB`;
    }
}
